export const namespace = 'canalplus.block.link_list';
export { default as Component } from './components/LinkList';
export { default as propsFormatter } from './propsFormatter';
